import { makeAutoObservable, observable  } from "mobx";
import materialStore from "../store/materialstore";
import { saveAs } from "file-saver";
import { MaterialService } from "../services/materialservices";
import moment from "moment";


class WizardStore {
  constructor() {
    makeAutoObservable(this);
  }

  productionDate = moment(new Date())._d;
  current = 0;
  materialStore = materialStore;
  isDownloadingTemplate = false;
  sheetName = "Material Template";
  importConsumptions = observable.map({});
  uploadErrors = observable.map({});
  async DownlaodTemplate() {
    try {
      this.isDownloadingTemplate = true;
      const asset = materialStore.mainStore.assetContextName;
      const assetId = materialStore.mainStore.assetContextId;

      const res = await MaterialService.downloadTemplate(asset, assetId);
      saveAs(res, `${asset}_material_cosumption_template.xlsx`,{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    } catch (error) {
      throw error;
    } finally {
      this.isDownloadingTemplate = false;
    }
  }
}


const wizardStore = new WizardStore();
export default wizardStore;

